module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "new-post"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Create new post")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addPost($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.title),
      expression: "newPost.title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.newPost.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPost.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Content")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.text),
      expression: "newPost.text"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Put your content here."
    },
    domProps: {
      "value": (_vm.newPost.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPost.text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "value": "Add Post",
      "disabled": _vm.newPost.title === '' && _vm.newPost.text === ''
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f201ad7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post.vue
// module id = 175
// module chunks = 1